import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';

import dateHoursFields from '../../../form/dateHoursFields';

const departmentTrainingForm: Form<Documentation> = {
  key: 'department',
  title: 'Dienststellenschulungen',
  fields: [
    ...dateHoursFields,
    {
      key: 'department',
      label: 'Dienststelle',
      fieldTypes: 'text',
    },
  ],
};

export default departmentTrainingForm;
